import { render, staticRenderFns } from "./UserCardRightsInternal.vue?vue&type=template&id=628e3f5b&scoped=true&"
import script from "./UserCardRightsInternal.vue?vue&type=script&lang=ts&"
export * from "./UserCardRightsInternal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e3f5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
